<template>
    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex mu-flex-row mu-w-100 mu-gap-04">
                <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                    <section class="mu-d-flex mu-flex-row mu-w-100">
                        <h1 class="mu-mb-00">User property details</h1>
                        <details class="mcc-popover mcc-popover--bottom-end">
                            <summary class="mcc-button mcc-button--icon-only ">
                                <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                            </summary>
                            <div class="mcc-popover__content">
                                <p>
                                    {{ (isEditPage) ? helpTextEdit.title : helpTextCreate.title }}
                                    <a :href="(isEditPage) ? helpTextEdit.url : helpTextCreate.url" target="_blank">Read
                                        more...</a>
                                </p>
                            </div>
                        </details>
                    </section>
                </div>
            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">User properties</a>
                    </li>
                    <li aria-current="page">{{ (isEditPage) ? userPropName : 'Create new' }}</li>
                    <li class="lastBredCrumpLi">
                    </li>
                </ol>
            </nav>
            <div class="mcc-row" v-if="fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                    style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none"
                                        stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card">
                            <div class="mcc-card__body">
                                <form novalidate id="userPropertyForm" ref="userPropertyForm"
                                    @submit.prevent="saveUserProperty()">
                                    <div class="mcc-row">
                                        <div class="mcc-col mcc-col-6">
                                            <div class="mcc-card fullHeightCard ">
                                                <div class="mcc-card__header">
                                                    <h4 class="mu-mb-00">Property</h4>
                                                </div>
                                                <div class="mcc-card__body ">
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">
                                                            <div
                                                                class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                                <label for="label"
                                                                    class="mfc-label--required mu-mb-00">Name</label>
                                                                <input type="text" id="label" name="label" required=""
                                                                    placeholder="Name" maxlength="50" ref="label"
                                                                    :value="userPropDTO.label" :pattern="descRegex"
                                                                    @change="updateName($event)">
                                                            </div>
                                                            <div
                                                                class="mfc-checkbox-wrapper mu-d-block mfc-form-input-container mu-mt-03">
                                                                <input type="checkbox" id="mandatory" class="mfc-switch"
                                                                    ref="mandatory"
                                                                    @change="handleManatoryTypeChange($event)"
                                                                    :checked="userPropDTO.mandatory">
                                                                <label for="mandatory" name="mandatory"
                                                                    color="primary">Mandatory</label>
                                                            </div>
                                                            <div
                                                                class="mfc-checkbox-wrapper mu-d-block mfc-form-input-container mu-mt-03">
                                                                <input type="checkbox" id="readOnly" class="mfc-switch"
                                                                    name="readOnly" ref="readOnly"
                                                                    @change="userPropDTO.readOnly = $event.target.checked"
                                                                    :checked="userPropDTO.readOnly" color="primary">
                                                                <label for="readOnly">Read only</label>
                                                            </div>
                                                            <div class="mfc-select-wrapper mu-mt-03">
                                                                <label for="type" class="mu-mb-00">Type</label>
                                                                <select name="type" block id="type" ref="type"
                                                                    @change="handleTypeChange($event)">
                                                                    <option :selected="userPropDTO.type === 'FREE_TEXT'"
                                                                        value="FREE_TEXT">Free text</option>
                                                                    <option :selected="userPropDTO.type === 'SELECTION'"
                                                                        value="SELECTION">Selection</option>
                                                                </select>
                                                            </div>
                                                            <div class="mfc-slim-select-wrapper mfc-form-input-container mu-mt-03 "
                                                                v-show="userPropDTO.type === 'SELECTION'"
                                                                id="defaultChoices">
                                                                <label for="defaultChoice"
                                                                    :class="userPropDTO.mandatory && ifAtleastOneEntryThere ? 'mfc-label--required mu-mb-00' : 'mu-mb-00'">Default
                                                                    Selection</label>
                                                                <select
                                                                    :required="userPropDTO.mandatory && ifAtleastOneEntryThere"
                                                                    name="defaultChoice" block label="Default selection"
                                                                    id="defaultChoice" ref="defaultChoice"
                                                                    @change="userPropDTO.defaultChoice = $event.target.value"></select>
                                                                <div class="mfc-invalid-feedback"></div>
                                                            </div>
                                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mt-03"
                                                                v-if="userPropDTO.type === 'FREE_TEXT'">
                                                                <label for="defaultValue"
                                                                    :class="userPropDTO.mandatory ? 'mfc-label--required mu-mb-00' : 'mu-mb-00'">Default
                                                                    value</label>
                                                                <input type="text" id="defaultValue" name="defaultValue"
                                                                    placeholder="Default value" maxlength="50"
                                                                    ref="defaultValue"
                                                                    :required="userPropDTO.mandatory === true"
                                                                    :value="userPropDTO.defaultValue"
                                                                    :pattern="descRegex"
                                                                    @change="updateDefaultValue($event)">
                                                            </div>
                                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mt-03"
                                                                v-if="userPropDTO.type === 'FREE_TEXT'">
                                                                <label for="defaultDescription"
                                                                    :class="userPropDTO.mandatory ? 'mfc-label--required mu-mb-00' : 'mu-mb-00'">Default
                                                                    description</label>
                                                                <input type="text" id="defaultDescription"
                                                                    name="defaultDescription"
                                                                    placeholder="Default description" maxlength="100"
                                                                    ref="defaultDescription"
                                                                    :required="userPropDTO.mandatory === true"
                                                                    :value="userPropDTO.defaultDescription"
                                                                    :pattern="descRegex"
                                                                    @change="updateDefaultDescription($event)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-col " v-show="userPropDTO.type === 'SELECTION'">
                                            <div class="mcc-card fullHeightCard">
                                                <div class="mcc-card__header">
                                                    <h2 class="mcc-card__title">Selection entries</h2>
                                                </div>
                                                <div class="mcc-card__body">
                                                    <mfc-row-repeater ref="userPropOptions" id="userPropOptions">
                                                        <mfc-input type="text" required="true" name="value" id="value" maxlength="50" label="Value" valattr="valattr"></mfc-input>
                                                        <mfc-input type="text" required="true" name="description" id="desc" maxlength="100" label="Description" descattr="descattr"></mfc-input>
                                                    </mfc-row-repeater>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end  mu-mt-05">
                                        <div class="mcc-button-group mcc-button-group--spaced">
                                            <button class="mcc-button mcc-button--soft-danger" type="button"
                                                v-if="isEditPage" id="deletePropBtn" @click="openDeleteUserPropDialog()"
                                                title="Delete">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Delete</span>
                                            </button>
                                            <router-link v-if="!isEditPage"
                                                :to="CONTEXT_PATH + '/usersgroups/userProperties'">
                                                <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn"
                                                    title="Cancel" type="button">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span
                                                        class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                            <button class="mcc-button mcc-button--success" id="saveBtn" type="submit"
                                                title="Save">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--danger" v-if="dataLoaded" id="deleteUserPropDialog"
                ref="deleteUserPropDialog">
                <form novalidate>
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Delete user property</h2>
                            <button type="button"
                                class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                                @click="closeDialog()">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
                        </div>
                        <div class="mcc-dialog__body">
                            Deleting this property from all users could invalidate a business process. Continue?
                        </div>
                        <div class="mcc-dialog__footer">

                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--outline"
                                    @click="closeDialog()">No</button>
                                <button type="button" class="mcc-button mcc-button--danger"
                                    @click="deleteUserProperty()">Yes</button>
                            </div>
                        </div>
                    </section>
                </form>
            </dialog>
        </div>
    </div>
</template>

<script>
import UserPropAPI from "../../../services/UserPropertyAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import UserPropertyAPI from '../../../services/UserPropertyAPI';
import Utils from "@/script_utils";
import {
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "UserPropertyEdit",
    data() {
        return {
            userPropDTO: {
                mandatory: true,
                readOnly: true,
                type: "FREE_TEXT",
                options: []
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["usersgroups.userproperties.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["usersgroups.userproperties.edit"],
            isEditPage: false,
            fetchCall: false,
            userPropName: '',
            userPropId: this.$route.params.userPropId,
            dataLoaded: false,
            ifAtleastOneEntryThere: false,
            updateCall: true,
            defaultChoiceObj: null,
            observer: null,
            isValid: true,
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.isEditPage = self.userPropId != null && self.userPropId != 'new';
        if (self.isEditPage) {
            let propOptions = [];
            let defChoicevalue = "";
            UserPropertyAPI.getUserPropertyInfo(self.userPropId).then(response => {
                self.fetchCall = true;
                if (response != undefined) {
                    self.dataLoaded = true;
                    self.userPropDTO = response;
                    self.userPropName = response.label;
                    self.$refs.type.value = response.type;
                    self.$refs.mandatory.checked = response.mandatory;
                    self.$refs.readOnly.checked = response.readOnly;
                    if (response.type == "SELECTION") {
                        if (self.userPropDTO.options != null && self.userPropDTO.options.length > 0) {
                            $.each(self.userPropDTO.options, function (i, val) {
                                let obj = {
                                    "value": val.value,
                                    "description": val.description,
                                    "default": val.defaultChoice
                                };
                                propOptions.push(obj);
                                if (val.defaultChoice == true) {
                                    defChoicevalue = val.value;
                                }
                            });
                        }
                    }
                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.userproperty.details"] + " - " + self.userPropName;
                    EventBus.$emit("update-pageTitle", pageTitle);
                }
            }).finally(() => {
                if (propOptions.length > 0) {
                    setTimeout(() => {
                        self.$refs.userPropOptions.setData(propOptions, {});
                        self.setDefaultChoiceAValue(defChoicevalue);
                    }, 1000);
                }
                self.fetchCall = false;
            });
        }
        self.defaultChoiceObj = new SlimSelect({
            select: '#defaultChoice',
        })
        this.$nextTick(() => {
            this.initMutationObserver()
        })

    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        performValidationsForValueField(component, dataVal) {
            let valid = true
            let pattern = new RegExp(this.descRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.required"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (dataVal.length > 100) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.maxlength"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.invalid"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (!Utils.isPropertyValid("vfAttr", "error.valueField.unique")) {
                valid = false
            } else {
                Utils.removeExistingMessages("vfAttr", this.descRegex, 100);
                component.classList.remove("ms-is-invalid")
                valid = true
            }
            return valid
        },
        performValidationsForDescField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.nameRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.description.required"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (dataVal.length > 50) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.description.maxlength"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.description.invalid"])
                component.classList.add("ms-is-invalid")
                valid = false
            } else if (!Utils.isPropertyValid("dfAttr", "error.description.unique")) {
                valid = false
            } else {
                Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
                component.classList.remove("ms-is-invalid")
                valid = true
            }
            return valid;
        },
        initMutationObserver() {
            const targetNode = this.$el.querySelector('#userPropOptions')
            const config = { childList: true, subtree: true };


            const callback = (mutationsList) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
                        this.updateDefaultChoiceDropdown();
                    }
                }
            };

            this.observer = new MutationObserver(callback);
            this.observer.observe(targetNode, config);
        },
        openDeleteUserPropDialog() {
            this.$refs.deleteUserPropDialog.show();
        },
        closeDialog() {
            this.$refs.deleteUserPropDialog.close();
        },
        setDefaultChoiceAValue(defChoicevalue) {
            let self = this;
            setTimeout(() => {
                self.updateDefaultChoiceDropdown();
                setTimeout(() => {
                    self.defaultChoiceObj.setSelected(defChoicevalue)
                }, 0);
            }, 0);
        },
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.userPropDTO?.label && this.userPropDTO.mandatory) {
                displayErrorMessage($(self.$refs.label), constantMessages.MESSAGES["error.name.required"])
                self.$refs.label.classList.add("ms-is-invalid")
                invalid = true;
            }
            if (!this.userPropDTO?.defaultValue && this.userPropDTO.type == "FREE_TEXT" && this.userPropDTO.mandatory) {
                displayErrorMessage($(self.$refs.defaultValue), constantMessages.MESSAGES["error.defaultValue.required"])
                self.$refs.defaultValue.classList.add("ms-is-invalid")
                invalid = true;
            }
            if (!this.userPropDTO?.defaultDescription && this.userPropDTO.type == "FREE_TEXT" && this.userPropDTO.mandatory) {
                displayErrorMessage($(self.$refs.defaultDescription), constantMessages.MESSAGES["error.defaultDescription.required"])
                self.$refs.defaultDescription.classList.add("ms-is-invalid")
                invalid = true;
            }
            if (this.userPropDTO.mandatory && this.ifAtleastOneEntryThere && $('#defaultChoice').val() == '') {
                displayErrorMessage($(self.$refs.defaultChoice), 'Default selection is required')
                self.$refs.defaultChoice.classList.add("ms-is-invalid")
                invalid = true;
            }
            return invalid;
        },
        saveUserProperty() {
            let self = this;
            self.isValid = true;
            this.checkRRValidations()
            if(!self.isValid){
                return;
            }

            if (self.handleValidation()) {
                return;
            }
            if (!Utils.isPropertyValid("valattr", "error.value.unique"))
                return;
            if (self.userPropDTO.type == "SELECTION") {
                let optionsList = [];
                let defChoicevalue = $("#defaultChoice")[0].value;
                let valueFieldComp;
                let value
                let descFieldComp;
                let desc;
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    valueFieldComp = $(row).find("input[name^=value]");
                    value = $(valueFieldComp).val();

                    descFieldComp = $(row).find("input[name^=description]");
                    desc = $(descFieldComp).val();

                    if (value != "" && desc != "") {
                        let obj = {
                            "value": value,
                            "description": desc,
                            "defaultChoice": (value == defChoicevalue ? true : false)
                        };
                        optionsList.push(obj);
                    }
                })
                if (optionsList.length > 0) {
                    self.userPropDTO.options = optionsList;
                } else {
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES["error.options.empty"]
                    });
                    return;
                }
            }
            self.updateCall = false;
            UserPropAPI.saveUserProperty(self.userPropDTO).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "label") {
                            displayErrorMessage($(self.$refs.label), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.label.classList.add("ms-is-invalid")
                        } else if (k == "defaultValue") {
                            displayErrorMessage($(self.$refs.defaultValue), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.defaultValue.classList.add("ms-is-invalid")
                        } else if (k == "defaultDescription") {
                            displayErrorMessage($(self.$refs.defaultDescription), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.defaultDescription.classList.add("ms-is-invalid")
                        } else if (k == "options") {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    if (!self.isEditPage) {
                        this.$router.push(this.CONTEXT_PATH +
                            "/usersgroups/userProperties/" + response.data.id);
                    } else {
                        self.userPropDTO = response.data;
                        self.userPropName = self.userPropDTO.label;
                        let propOptions = [];
                        let defChoicevalue = "";
                        if (response.data.type == "SELECTION") {
                            if (self.userPropDTO.options != null && self.userPropDTO.options.length > 0) {
                                $.each(self.userPropDTO.options, function (i, val) {
                                    let obj = {
                                        "value": val.value,
                                        "description": val.description,
                                        "defaultChoice": val.defaultChoice
                                    };
                                    propOptions.push(obj);
                                    if (val.defaultChoice == true) {
                                        defChoicevalue = val.value;
                                    }
                                });
                                self.$refs.userPropOptions.setData(propOptions, {});
                                self.setDefaultChoiceAValue(defChoicevalue);
                            }
                            self.$refs.defaultChoice.classList.remove("ms-is-invalid")
                        } else {
                            self.$refs.defaultValue.classList.remove("ms-is-invalid")
                            self.$refs.defaultDescription.classList.remove("ms-is-invalid")
                        }
                    }
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.label), constantMessages.MESSAGES["error.name.required"])
                self.$refs.label.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.label), constantMessages.MESSAGES["error.name.length"])
                self.$refs.label.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.label), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.label.classList.add("ms-is-invalid")
            } else {
                self.$refs.label.classList.remove("ms-is-invalid")
            }
            self.userPropDTO.label = event.target.value;
        },
        updateDefaultValue(event) {
            let self = this;
            if (event.target.value == "" && this.userPropDTO.mandatory) {
                displayErrorMessage($(self.$refs.defaultValue), constantMessages.MESSAGES["error.defaultValue.required"])
                self.$refs.defaultValue.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.defaultValue), constantMessages.MESSAGES["error.defaultValue.length"])
                self.$refs.defaultValue.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.defaultValue), constantMessages.MESSAGES["error.defaultValue.invalid"])
                self.$refs.defaultValue.classList.add("ms-is-invalid")
            } else {
                self.$refs.defaultValue.classList.remove("ms-is-invalid")
            }
            self.userPropDTO.defaultValue = event.target.value;
        },
        updateDefaultDescription(event) {
            let self = this;
            if (event.target.value == "" && this.userPropDTO.mandatory) {
                displayErrorMessage($(self.$refs.defaultDescription), constantMessages.MESSAGES["error.defaultDescription.required"])
                self.$refs.defaultDescription.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.defaultDescription), constantMessages.MESSAGES["error.defaultDescription.length"])
                self.$refs.defaultDescription.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.defaultDescription), constantMessages.MESSAGES["error.defaultDescription.invalid"])
                self.$refs.defaultDescription.classList.add("ms-is-invalid")
            } else {
                self.$refs.defaultDescription.classList.remove("ms-is-invalid")
            }

            self.userPropDTO.defaultDescription = event.target.value;
        },
        validateRowRepeaterFields(event) {
            if (!event) {
                if ($(".mcc-row-repeater .mcc-row-repeater__row").length == 1) {
                    self.ifAtleastOneEntryThere = false;
                } else {
                    self.ifAtleastOneEntryThere = true;
                }
            }
            if (event.target.id == 'value') {
                this.updateValueField();
            }
            if (event.target.id == 'desc') {
                this.updateDescriptionField();
            }
        },
        updateValueField() {
            Utils.removeExistingMessages("valattr", this.nameRegex, 50);
            this.updateDefaultChoiceDropdown();
        },
        updateDescriptionField() {
            this.updateDefaultChoiceDropdown();
        },
        handleRowRemoveOperation() {
            this.updateDefaultChoiceDropdown();
        },
        updateDefaultChoiceDropdown() {
            let self = this;
            let valuePattern = new RegExp(this.descRegex);
            let descriptionPattern = new RegExp(this.nameRegex);
            let oldSelectedVal = $("#defaultChoice")[0].value;
            let isPersistSelection = false;
            let arrayOptions = [{
                text: 'Select Value',
                value: '',
                display: false
            }];;
            if ($(".mcc-row-repeater .mcc-row-repeater__row").length == 1 && self.ifAtleastOneEntryThere) {
                self.ifAtleastOneEntryThere = false;
            } else {
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (i, row) {
                    const valueFieldComp = $(row).find("input[name^=value]");
                    const value = $(valueFieldComp).val();
                    const descFieldComp = $(row).find("input[name^=description]");
                    const desc = $(descFieldComp).val();
                    if (value != "" && desc != "" && value.length <= 50 && desc.length <= 100 && valuePattern.test(value) && descriptionPattern.test(desc)) {
                        self.ifAtleastOneEntryThere = true;
                        var option = {
                            text: `${value} - ${desc}`,
                            value: value
                        };
                        arrayOptions.push(option);
                        if (value == oldSelectedVal) {
                            isPersistSelection = true;
                        }
                    }

                });
                self.defaultChoiceObj.setData(arrayOptions)
                if (isPersistSelection && oldSelectedVal !== '') {
            self.defaultChoiceObj.setSelected(oldSelectedVal);
        } else {
            self.defaultChoiceObj.setSelected(''); 
        }
            }

            $(".mcc-row-repeater [valattr=valattr]").on("change", function (e) {
        if (e.target.name !== 'value-rr-0') {
            let valueValid = self.performValidationsForValueField(e.target, e.target.value);
            if (!valueValid) {
                self.isValid = false;
                e.stopPropagation()
            } 
        }
    });

    $(".mcc-row-repeater [descattr=descattr]").on("change", function (e) {
        if (e.target.name !== 'description-rr-0') {
            let descValid = self.performValidationsForDescField(e.target, e.target.value);
            if (!descValid) {
                self.isValid = false;
                    e.stopPropagation()

            } 
        }
    });


        },
        checkRRValidations()
        {
            let self = this
            $(".mcc-row-repeater [valattr=valattr]").each(function () {
                let inputElement = $(this).find("input");
                if (inputElement && inputElement[0].name !== 'value-rr-0') {
    let valueValid = self.performValidationsForValueField(inputElement[0], inputElement.val());
                
    if (!valueValid) {
        self.isValid = false;
    }
}
});

$(".mcc-row-repeater [descattr=descattr]").each(function () {
    let inputEle = $(this).find("input");
    if (inputEle && inputEle[0].name !== 'description-rr-0') {
    let descValid = self.performValidationsForDescField(inputEle[0], inputEle.val());
    if (!descValid) {
        self.isValid = false;
    }
    }
});
        },
        deleteUserProperty() {
            let self = this;
            self.$refs.deleteUserPropDialog.close()
            self.updateCall = false;
            UserPropertyAPI.deleteUserProperty(
                self.$route.params.userPropId).then(response => {
                    self.updateCall = true;
                    if (response != null && !response.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.$router.push(self.CONTEXT_PATH + '/usersgroups/userProperties');
                    }
                });
        },
        handleTypeChange(e) {
            let selectedType = e.target.value;
            this.userPropDTO.type = selectedType;
            if (selectedType == 'SELECTION') {
                this.userPropDTO.defaultValue = ""
                this.userPropDTO.defaultDescription = "";
            }
        },
        redirectToList() {
            localStorage.setItem("userProperty", "userProperty");
            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/userProperties'
            );
        },
        handleManatoryTypeChange(e) {
            let self = this;
            self.userPropDTO.mandatory = e.target.checked;
            if (!e.target.checked) {
                self.$refs.defaultValue.classList.remove("ms-is-invalid")
                self.$refs.defaultDescription.classList.remove("ms-is-invalid")
            }
        }
    }
}
</script>
